import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';

import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { IEffect } from '../../../../../../shared/modules/dynamic-effects/effect.interface';
import {
  LOAD_ADDRESS,
  LoadJobsiteAddress,
  LoadJobsiteAddressComplete,
  LoadJobsiteAddressFail,
} from '../../../actions/jobsite-actions/jobsite.actions';
import { AddressesService } from '@cemex-core/cmx-api';
import { IAddressResponse } from '@cemex-core/cmx-api/models/addresses-req-management/addresses-response';

@Injectable()
export class JobsiteLoadAddressEffects implements IEffect {
  /**
   * Monitors the actions$ Actions stream (it's a sub-type of Observable) for
   * LOAD_ADDRESS events; then attempts to get a jobsite's physical address as
   * an IAddressResponse object from the injected AddressesService; and finally
   * handles success or failure when getting the address details.
   * @type {Observable<LoadJobsiteAddressComplete | LoadJobsiteAddressFail>} the result of the address-loading operation
   */

  JobsiteLoadAddress$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(LOAD_ADDRESS),
      switchMap((payload: LoadJobsiteAddress) => {
        return this.addressesService.getAddress(payload.payload).pipe(
          map((addressResponse: IAddressResponse) => {
            return new LoadJobsiteAddressComplete(addressResponse);
          }),
          catchError((error) => of(new LoadJobsiteAddressFail(error))),
        );
      }),
    ),
  );

  loadTrigger$: Observable<Action> = createEffect(
    () =>
      this.actions$.pipe(
        ofType(LOAD_ADDRESS),
        tap((payload: LoadJobsiteAddress) => {
          return;
        }),
      ),
    { dispatch: false },
  );

  constructor(
    private actions$: Actions,
    private addressesService: AddressesService,
  ) {}
}
